import { render, staticRenderFns } from "./flyProduct.vue?vue&type=template&id=d2de8212&scoped=true"
import script from "./flyProduct.vue?vue&type=script&lang=js"
export * from "./flyProduct.vue?vue&type=script&lang=js"
import style0 from "./flyProduct.vue?vue&type=style&index=0&id=d2de8212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2de8212",
  null
  
)

export default component.exports